import React from 'react';
import ReturningBuyer from '../returning_buyer';
import PreviewImg from '../preview_img/PreviewImg';
import Rating from '../../rating/rating';
import classnames from 'classnames';
import './ReviewItem.scss';

const ReviewItem = (props) => {
    const {
        review,
        gigId
    } = props;

    const isSeller = review.get('is_seller'),
        isReturningBuyer = review.get('sbss'),
        raterImage = review.get('rater_image_url'),
        username = review.get('rater_username'),
        shouldHideReview = isSeller && !gigId;

    if (shouldHideReview) {
        return null;
    }

    return (
        <li className={classnames({seller: isSeller})}>

            {!isSeller && <PreviewImg smallImgUrl={review.get('work_sample_small')} bigImgUrl={review.get('work_sample')}/>}

            <span className="user-pict-32">
                {raterImage ?
                    (<img src={raterImage} alt={username}/>) :
                    (<span className="missing-image-user">{username.substring(0, 1)}</span>)
                }
            </span>

            <header>
                {isReturningBuyer && <ReturningBuyer/>}
                <h5>{isSeller ? i18n.t('reviews.users.show.seller_feedback') : username}</h5>
                <Rating ratingFive={review.get('value')/2}/>
            </header>

            <p>{review.get('comment')}</p>
            <time>{review.get('created_at')} {i18n.t('reviews.general.ago')}</time>

        </li>
    );
};

export default ReviewItem;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/review_item/ReviewItem.js